// NPM
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { selectTopTagEntities } from 'selectors';

import RankedList from './RankedList';
import TagBarGraph from './TagBarGraph';
import RemainderBarGraph from './RemainderBarGraph';

class PercentageRankedList extends PureComponent {
  render() {
    const { heading, topTags, totalCount, schema, tags } = this.props;
    const percentages = topTags.map(item => {
      return item.weightedCount / totalCount * 100;
    });
    if (!topTags.length) return null;
    return (
      <RankedList id={`PercentageRankedList-${schema}`} heading={heading}>
        {topTags.map((topTag, i) => {
          const tag = tags[i];
          return (
            <li className="TagBarGraph-list-item" key={i}>
              <TagBarGraph tag={tag} percentage={percentages[i]} />
            </li>
          );
        })}
        <li className="TagBarGraph-list-item">
          <RemainderBarGraph
            percentages={percentages}
            topTags={topTags}
            schema={schema}
          />
        </li>
      </RankedList>
    );
  }
}

PercentageRankedList.propTypes = {
  schema: PropTypes.string.isRequired,
  topTags: PropTypes.array.isRequired,
  heading: PropTypes.string.isRequired,
  tags: PropTypes.array.isRequired,
  totalCount: PropTypes.number.isRequired,
};

PercentageRankedList.defaultProps = {
  topTags: [],
};

function mapStateToProps(state, props) {
  return {
    topTags: state.entities.summaries.topTags[props.schema],
    tags: selectTopTagEntities(state, props.schema),
    totalCount: state.entities.recommendations.allIds.length,
  };
}

export default connect(mapStateToProps)(PercentageRankedList);



// WEBPACK FOOTER //
// ./src/Components/Pages/Results/RankedLists/PercentageRankedList.js